import { CarouselTypes } from "./constants";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { size, color, opacity } = ids;
const getImageSize = (imageSize) => {
    switch (imageSize) {
        case "xsmall":
            return `
      width: 148px;
    `;
        case "small":
            return `
      width: 187px;
    `;
        case "medium":
            return `
      width: 268px;
    `;
        case "large":
            return `
      width: 312px;
    `;
        case "xlarge":
            return `
      width: 390px;
    `;
        case "huge":
            return `
      width: 406px;
    `;
    }
    return;
};
const getImageBorder = (border) => {
    switch (border) {
        case "all":
            return `
      border-radius: ${size.general.ids_size_general_12x};
    `;
        case "none":
            return `
      border-radius: unset;
    `;
        case "top":
            return `
      border-top-left-radius: ${size.general.ids_size_general_12x};
      border-top-right-radius: ${size.general.ids_size_general_12x};
    `;
        case "left":
            return `
      border-top-left-radius: ${size.general.ids_size_general_12x};
      border-bottom-left-radius: ${size.general.ids_size_general_12x};
    `;
    }
};
export const CarouselContainer = styled.div `
  position: relative;
  ${({ imageSize, carouselType }) => carouselType === CarouselTypes.default && getImageSize(imageSize)}
    .overlay::before {
      ${({ borderRadius }) => getImageBorder(borderRadius)}
      content: "";
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      background: linear-gradient(0deg, ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_strong)}, ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)} 30%);
    }
    .slick-list{
      ${({ borderRadius }) => getImageBorder(borderRadius)}
    }
`;
export const CarouselIndicator = styled.div `
  position: absolute;
  left: ${size.general.ids_size_general_16x};
  bottom: 15px;
  z-index: 10;
`;
export const CarouselButtons = styled.div `
  position: absolute;
  display: flex;
  z-index: 10;
  bottom: ${size.general.ids_size_general_8x};
  right: ${size.general.ids_size_general_8x};
`;
export const CarouselDots = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
`;
//# sourceMappingURL=Carousel.style.js.map